import React from "react"
import {
	Grid
} from "@material-ui/core"

import SubscriptionDataPortlet from "@/components/Signature/SubscriptionDataPortlet"
import { usePermissionStateStore } from "@/store/PermissionState"

const Signature = () => {
	const { checkPermission } = usePermissionStateStore()

	const canAccessSubscriptions = checkPermission("manager-panel", "subscriptions-access")

	if (!canAccessSubscriptions) {
		return null
	}

	return (
		<Grid
			container
			direction="column"
			spacing={2}
		>
			<Grid
				item
				xs={12}
			>
				<SubscriptionDataPortlet />
			</Grid>
		</Grid>
	)
}

export default Signature
